/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SSOSyncConfig } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * SSOAPIApi - axios parameter creator
 * @export
 */
export const SSOAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CreateSSOSyncConfig creates the sync configuration for an SSO connection,  stores provider-specific configuration, and triggers an initial sync.
         * @summary Create SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {SSOSyncConfig} sSOSyncConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPICreateSSOSyncConfig: async (organizationId: string, ssoConnectionId: string, sSOSyncConfig: SSOSyncConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sSOAPICreateSSOSyncConfig', 'organizationId', organizationId)
            // verify required parameter 'ssoConnectionId' is not null or undefined
            assertParamExists('sSOAPICreateSSOSyncConfig', 'ssoConnectionId', ssoConnectionId)
            // verify required parameter 'sSOSyncConfig' is not null or undefined
            assertParamExists('sSOAPICreateSSOSyncConfig', 'sSOSyncConfig', sSOSyncConfig)
            const localVarPath = `/organization-management/v1beta/organizations/{organizationId}/sso-connections/{ssoConnectionId}/sync/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"ssoConnectionId"}}`, encodeURIComponent(String(ssoConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sSOSyncConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DeleteSSOSyncConfig deletes the sync configuration for an SSO connection:  it removes provider-specific configurations and soft-deletes the sync config row.
         * @summary Delete SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPIDeleteSSOSyncConfig: async (organizationId: string, ssoConnectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sSOAPIDeleteSSOSyncConfig', 'organizationId', organizationId)
            // verify required parameter 'ssoConnectionId' is not null or undefined
            assertParamExists('sSOAPIDeleteSSOSyncConfig', 'ssoConnectionId', ssoConnectionId)
            const localVarPath = `/organization-management/v1beta/organizations/{organizationId}/sso-connections/{ssoConnectionId}/sync/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"ssoConnectionId"}}`, encodeURIComponent(String(ssoConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetSSOSyncConfig returns the sync configuration together with the last sync status for an SSO connection.
         * @summary Get SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPIGetSSOSyncConfig: async (organizationId: string, ssoConnectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sSOAPIGetSSOSyncConfig', 'organizationId', organizationId)
            // verify required parameter 'ssoConnectionId' is not null or undefined
            assertParamExists('sSOAPIGetSSOSyncConfig', 'ssoConnectionId', ssoConnectionId)
            const localVarPath = `/organization-management/v1beta/organizations/{organizationId}/sso-connections/{ssoConnectionId}/sync/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"ssoConnectionId"}}`, encodeURIComponent(String(ssoConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateSSOSyncConfig replaces the sync config for an SSO connection and triggers a sync.  Config is fully overwritten, except credentials, which are kept if omitted.
         * @summary Update SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {SSOSyncConfig} sSOSyncConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPIUpdateSSOSyncConfig: async (organizationId: string, ssoConnectionId: string, sSOSyncConfig: SSOSyncConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sSOAPIUpdateSSOSyncConfig', 'organizationId', organizationId)
            // verify required parameter 'ssoConnectionId' is not null or undefined
            assertParamExists('sSOAPIUpdateSSOSyncConfig', 'ssoConnectionId', ssoConnectionId)
            // verify required parameter 'sSOSyncConfig' is not null or undefined
            assertParamExists('sSOAPIUpdateSSOSyncConfig', 'sSOSyncConfig', sSOSyncConfig)
            const localVarPath = `/organization-management/v1beta/organizations/{organizationId}/sso-connections/{ssoConnectionId}/sync/config`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"ssoConnectionId"}}`, encodeURIComponent(String(ssoConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sSOSyncConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SSOAPIApi - functional programming interface
 * @export
 */
export const SSOAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SSOAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * CreateSSOSyncConfig creates the sync configuration for an SSO connection,  stores provider-specific configuration, and triggers an initial sync.
         * @summary Create SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {SSOSyncConfig} sSOSyncConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sSOAPICreateSSOSyncConfig(organizationId: string, ssoConnectionId: string, sSOSyncConfig: SSOSyncConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SSOSyncConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sSOAPICreateSSOSyncConfig(organizationId, ssoConnectionId, sSOSyncConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOAPIApi.sSOAPICreateSSOSyncConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * DeleteSSOSyncConfig deletes the sync configuration for an SSO connection:  it removes provider-specific configurations and soft-deletes the sync config row.
         * @summary Delete SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sSOAPIDeleteSSOSyncConfig(organizationId: string, ssoConnectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sSOAPIDeleteSSOSyncConfig(organizationId, ssoConnectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOAPIApi.sSOAPIDeleteSSOSyncConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetSSOSyncConfig returns the sync configuration together with the last sync status for an SSO connection.
         * @summary Get SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sSOAPIGetSSOSyncConfig(organizationId: string, ssoConnectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SSOSyncConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sSOAPIGetSSOSyncConfig(organizationId, ssoConnectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOAPIApi.sSOAPIGetSSOSyncConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * UpdateSSOSyncConfig replaces the sync config for an SSO connection and triggers a sync.  Config is fully overwritten, except credentials, which are kept if omitted.
         * @summary Update SSO sync configuration for an SSO connection.
         * @param {string} organizationId Organization ID.
         * @param {string} ssoConnectionId SSO connection ID.
         * @param {SSOSyncConfig} sSOSyncConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sSOAPIUpdateSSOSyncConfig(organizationId: string, ssoConnectionId: string, sSOSyncConfig: SSOSyncConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SSOSyncConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sSOAPIUpdateSSOSyncConfig(organizationId, ssoConnectionId, sSOSyncConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOAPIApi.sSOAPIUpdateSSOSyncConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SSOAPIApi - factory interface
 * @export
 */
export const SSOAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SSOAPIApiFp(configuration)
    return {
        /**
         * CreateSSOSyncConfig creates the sync configuration for an SSO connection,  stores provider-specific configuration, and triggers an initial sync.
         * @summary Create SSO sync configuration for an SSO connection.
         * @param {SSOAPIApiSSOAPICreateSSOSyncConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPICreateSSOSyncConfig(requestParameters: SSOAPIApiSSOAPICreateSSOSyncConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<SSOSyncConfig> {
            return localVarFp.sSOAPICreateSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, requestParameters.sSOSyncConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * DeleteSSOSyncConfig deletes the sync configuration for an SSO connection:  it removes provider-specific configurations and soft-deletes the sync config row.
         * @summary Delete SSO sync configuration for an SSO connection.
         * @param {SSOAPIApiSSOAPIDeleteSSOSyncConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPIDeleteSSOSyncConfig(requestParameters: SSOAPIApiSSOAPIDeleteSSOSyncConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sSOAPIDeleteSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetSSOSyncConfig returns the sync configuration together with the last sync status for an SSO connection.
         * @summary Get SSO sync configuration for an SSO connection.
         * @param {SSOAPIApiSSOAPIGetSSOSyncConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPIGetSSOSyncConfig(requestParameters: SSOAPIApiSSOAPIGetSSOSyncConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<SSOSyncConfig> {
            return localVarFp.sSOAPIGetSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateSSOSyncConfig replaces the sync config for an SSO connection and triggers a sync.  Config is fully overwritten, except credentials, which are kept if omitted.
         * @summary Update SSO sync configuration for an SSO connection.
         * @param {SSOAPIApiSSOAPIUpdateSSOSyncConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sSOAPIUpdateSSOSyncConfig(requestParameters: SSOAPIApiSSOAPIUpdateSSOSyncConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<SSOSyncConfig> {
            return localVarFp.sSOAPIUpdateSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, requestParameters.sSOSyncConfig, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sSOAPICreateSSOSyncConfig operation in SSOAPIApi.
 * @export
 * @interface SSOAPIApiSSOAPICreateSSOSyncConfigRequest
 */
export interface SSOAPIApiSSOAPICreateSSOSyncConfigRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPICreateSSOSyncConfig
     */
    readonly organizationId: string

    /**
     * SSO connection ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPICreateSSOSyncConfig
     */
    readonly ssoConnectionId: string

    /**
     * 
     * @type {SSOSyncConfig}
     * @memberof SSOAPIApiSSOAPICreateSSOSyncConfig
     */
    readonly sSOSyncConfig: SSOSyncConfig
}

/**
 * Request parameters for sSOAPIDeleteSSOSyncConfig operation in SSOAPIApi.
 * @export
 * @interface SSOAPIApiSSOAPIDeleteSSOSyncConfigRequest
 */
export interface SSOAPIApiSSOAPIDeleteSSOSyncConfigRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPIDeleteSSOSyncConfig
     */
    readonly organizationId: string

    /**
     * SSO connection ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPIDeleteSSOSyncConfig
     */
    readonly ssoConnectionId: string
}

/**
 * Request parameters for sSOAPIGetSSOSyncConfig operation in SSOAPIApi.
 * @export
 * @interface SSOAPIApiSSOAPIGetSSOSyncConfigRequest
 */
export interface SSOAPIApiSSOAPIGetSSOSyncConfigRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPIGetSSOSyncConfig
     */
    readonly organizationId: string

    /**
     * SSO connection ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPIGetSSOSyncConfig
     */
    readonly ssoConnectionId: string
}

/**
 * Request parameters for sSOAPIUpdateSSOSyncConfig operation in SSOAPIApi.
 * @export
 * @interface SSOAPIApiSSOAPIUpdateSSOSyncConfigRequest
 */
export interface SSOAPIApiSSOAPIUpdateSSOSyncConfigRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPIUpdateSSOSyncConfig
     */
    readonly organizationId: string

    /**
     * SSO connection ID.
     * @type {string}
     * @memberof SSOAPIApiSSOAPIUpdateSSOSyncConfig
     */
    readonly ssoConnectionId: string

    /**
     * 
     * @type {SSOSyncConfig}
     * @memberof SSOAPIApiSSOAPIUpdateSSOSyncConfig
     */
    readonly sSOSyncConfig: SSOSyncConfig
}

/**
 * SSOAPIApi - object-oriented interface
 * @export
 * @class SSOAPIApi
 * @extends {BaseAPI}
 */
export class SSOAPIApi extends BaseAPI {
    /**
     * CreateSSOSyncConfig creates the sync configuration for an SSO connection,  stores provider-specific configuration, and triggers an initial sync.
     * @summary Create SSO sync configuration for an SSO connection.
     * @param {SSOAPIApiSSOAPICreateSSOSyncConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOAPIApi
     */
    public sSOAPICreateSSOSyncConfig(requestParameters: SSOAPIApiSSOAPICreateSSOSyncConfigRequest, options?: RawAxiosRequestConfig) {
        return SSOAPIApiFp(this.configuration).sSOAPICreateSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, requestParameters.sSOSyncConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DeleteSSOSyncConfig deletes the sync configuration for an SSO connection:  it removes provider-specific configurations and soft-deletes the sync config row.
     * @summary Delete SSO sync configuration for an SSO connection.
     * @param {SSOAPIApiSSOAPIDeleteSSOSyncConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOAPIApi
     */
    public sSOAPIDeleteSSOSyncConfig(requestParameters: SSOAPIApiSSOAPIDeleteSSOSyncConfigRequest, options?: RawAxiosRequestConfig) {
        return SSOAPIApiFp(this.configuration).sSOAPIDeleteSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetSSOSyncConfig returns the sync configuration together with the last sync status for an SSO connection.
     * @summary Get SSO sync configuration for an SSO connection.
     * @param {SSOAPIApiSSOAPIGetSSOSyncConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOAPIApi
     */
    public sSOAPIGetSSOSyncConfig(requestParameters: SSOAPIApiSSOAPIGetSSOSyncConfigRequest, options?: RawAxiosRequestConfig) {
        return SSOAPIApiFp(this.configuration).sSOAPIGetSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateSSOSyncConfig replaces the sync config for an SSO connection and triggers a sync.  Config is fully overwritten, except credentials, which are kept if omitted.
     * @summary Update SSO sync configuration for an SSO connection.
     * @param {SSOAPIApiSSOAPIUpdateSSOSyncConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOAPIApi
     */
    public sSOAPIUpdateSSOSyncConfig(requestParameters: SSOAPIApiSSOAPIUpdateSSOSyncConfigRequest, options?: RawAxiosRequestConfig) {
        return SSOAPIApiFp(this.configuration).sSOAPIUpdateSSOSyncConfig(requestParameters.organizationId, requestParameters.ssoConnectionId, requestParameters.sSOSyncConfig, options).then((request) => request(this.axios, this.basePath));
    }
}

